import {
  Injectable, Provider, Type,
} from '@angular/core'
import { Subject } from 'rxjs'

export function provideHeaderSearchIntl(intl: Type<HeaderSearchIntl>): Provider {
  return {
    provide: HeaderSearchIntl,
    useClass: intl,
  }
}

@Injectable({ providedIn: 'root' })
export class HeaderSearchIntl {
  public readonly changes$ = new Subject<void>()

  public searchInputLabel = 'Search'

  public searchSubmitLabel = 'Search'

  public openSearchButtonLabel = 'Open search'

  public closeSearchButtonLabel = 'Close search'
}
